import { Loader } from "@circle-react-uikit/Loader";
import { Table, TableBody } from "@circle-react-uikit/Table";
import { useCommunityMembersInfiniteQuery } from "@circle-react/hooks/useCommunityMembersInfiniteQuery";
import InfiniteScroll from "react-infinite-scroll-component";
import { keepPreviousData } from "react-query";

import { Row } from "../Row";
import type { MembersToAddListProps } from "./types";

export const MembersToAddListUIKit = ({
  memberIds = [],
  onRemove,
}: MembersToAddListProps) => {
  const hasIds = memberIds.length > 0;

  const { hasNextPage, fetchNextPage, members } =
    useCommunityMembersInfiniteQuery({
      filters: { id: memberIds },
      options: {
        enabled: hasIds,
        placeholderData: hasIds ? keepPreviousData : undefined,
      },
    });

  if (!hasIds) {
    return null;
  }

  return (
    <div className="mt-4 h-full max-h-80 overflow-y-auto">
      <InfiniteScroll
        loader={<Loader />}
        dataLength={memberIds.length}
        style={{ overflow: "initial" }}
        scrollThreshold={0.5}
        next={fetchNextPage}
        hasMore={Boolean(hasNextPage)}
      >
        <Table
          variant="no-border"
          className="w-full max-w-full"
          tableClassName="w-full"
        >
          <TableBody>
            {members.map(({ id, avatar_url, name, email }) => (
              <Row
                key={id}
                id={id}
                avatarUrl={avatar_url}
                name={name}
                email={email}
                onRemove={onRemove}
              />
            ))}
          </TableBody>
        </Table>
      </InfiniteScroll>
    </div>
  );
};
